export default __webpack_public_path__ + "static/media/AltoLogo_256x256.f6a6d616.jpg";